import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import type { SortDirection } from '@kioskgaming/ui/dist/data-table/sortState';
import { fetchAgentOnlineBalanceLedger } from '../services/api';

export type UseAgentOnlineBalanceLedgerParams = {
  currency?: string;
  type?: string;
  status?: string;
  query?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  limit?: number;
  sortBy?: string | null;
  sortOrder?: SortDirection | null;
  enabled?: boolean;
};

export function useAgentOnlineBalanceLedger(params: UseAgentOnlineBalanceLedgerParams = {}) {
  const {
    currency = 'USD',
    type,
    status,
    query,
    dateFrom,
    dateTo,
    page = 1,
    limit = 50,
    sortBy,
    sortOrder,
    enabled = true,
  } = params;

  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!enabled) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const res = await fetchAgentOnlineBalanceLedger({
        currency,
        ...(type ? { type } : {}),
        ...(status ? { status } : {}),
        ...(query ? { query } : {}),
        ...(dateFrom ? { dateFrom } : {}),
        ...(dateTo ? { dateTo } : {}),
        page,
        limit,
        ...(sortBy ? { sortBy } : {}),
        ...(sortOrder ? { sortOrder } : {}),
      });
      if (res.success && res.data) setData(res.data);
      else setData(null);
    } catch {
      toast.error('Could not load USD wallet ledger');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [enabled, currency, type, status, query, dateFrom, dateTo, page, limit, sortBy, sortOrder]);

  useEffect(() => {
    void load();
  }, [load]);

  return { data, loading, reload: load };
}
